// Shared color tokens for school-segment pills. Tailwind can't build class names
// dynamically, so each token maps to fully-spelled classes here. Used by the
// segment editor, project card, and lead pills so a school looks the same
// everywhere.

export const SEGMENT_COLORS = [
  'indigo', 'emerald', 'amber', 'sky', 'rose', 'violet', 'teal', 'orange',
] as const;

export type SegmentColor = typeof SEGMENT_COLORS[number];

const PILL_CLASSES: Record<string, string> = {
  indigo: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  emerald: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  amber: 'bg-amber-100 text-amber-800 border-amber-200',
  sky: 'bg-sky-100 text-sky-800 border-sky-200',
  rose: 'bg-rose-100 text-rose-800 border-rose-200',
  violet: 'bg-violet-100 text-violet-800 border-violet-200',
  teal: 'bg-teal-100 text-teal-800 border-teal-200',
  orange: 'bg-orange-100 text-orange-800 border-orange-200',
};

const DOT_CLASSES: Record<string, string> = {
  indigo: 'bg-indigo-500',
  emerald: 'bg-emerald-500',
  amber: 'bg-amber-500',
  sky: 'bg-sky-500',
  rose: 'bg-rose-500',
  violet: 'bg-violet-500',
  teal: 'bg-teal-500',
  orange: 'bg-orange-500',
};

/** Pill background/text/border classes for a segment color token. */
export const segmentPillClass = (color?: string): string =>
  PILL_CLASSES[color || ''] || 'bg-gray-100 text-gray-800 border-gray-200';

/** Solid dot/swatch class for a segment color token. */
export const segmentDotClass = (color?: string): string =>
  DOT_CLASSES[color || ''] || 'bg-gray-400';

/** Pick a default color for the Nth segment, cycling through the palette. */
export const nextSegmentColor = (index: number): SegmentColor =>
  SEGMENT_COLORS[index % SEGMENT_COLORS.length];

/** Generate a stable client-side id for a new segment. */
export const newSegmentId = (): string =>
  `seg-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
